import { useEffect, useState } from "react";
import { api, errDetail, fmtDate } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Bot, Sparkles, RefreshCw } from "lucide-react";

export function SupplierAiEvaluation({ id }) {
  const [ev, setEv] = useState(null);
  const [loading, setLoading] = useState(true);
  const [gen, setGen] = useState(false);

  const load = () => {
    setLoading(true);
    api.get(`/suppliers/${id}/ai-evaluation`)
      .then((r) => setEv(r.data && r.data.narrative ? r.data : null))
      .catch(() => setEv(null))
      .finally(() => setLoading(false));
  };
  useEffect(load, [id]); // eslint-disable-line

  const generate = async () => {
    setGen(true);
    try {
      const r = await api.post(`/suppliers/${id}/ai-evaluation`);
      setEv(r.data);
      toast.success("KI-Bewertung erstellt");
    } catch (e) {
      toast.error(errDetail(e));
    } finally {
      setGen(false);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-testid="supplier-ai-evaluation">
      <div className="bg-[#1B2A4A] px-5 py-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-lg bg-white/10 flex items-center justify-center">
            <Bot className="h-5 w-5 text-[#F5A623]" />
          </div>
          <div>
            <div className="text-white font-semibold leading-tight">KI-Lieferantenbewertung</div>
            <div className="text-white/60 text-xs">
              {ev?.created_at ? `Zuletzt erstellt ${fmtDate(ev.created_at)}${ev.generated_by_name ? " · " + ev.generated_by_name : ""}` : "Noch keine Bewertung erstellt"}
            </div>
          </div>
        </div>
        <Button onClick={generate} disabled={gen} data-testid="supplier-ai-eval-generate-btn"
          className="bg-[#F5A623] hover:bg-[#e0951a] text-[#1B2A4A] font-semibold">
          {gen ? <RefreshCw className="h-4 w-4 mr-2 animate-spin" /> : <Sparkles className="h-4 w-4 mr-2" />}
          {ev ? "Aktualisieren" : "KI-Bewertung erzeugen"}
        </Button>
      </div>
      <div className="p-5">
        {loading ? (
          <p className="text-sm text-gray-400">Wird geladen…</p>
        ) : !ev ? (
          <p className="text-sm text-gray-500" data-testid="supplier-ai-eval-empty">
            Erzeugt aus den internen Kennzahlen (Scorecard, Reklamationen, Profil) eine strukturierte
            Bewertung mit Score und Maßnahmen. Der Aufruf wird in der KI-Nutzungsstatistik erfasst.
          </p>
        ) : (
          <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed" data-testid="supplier-ai-eval-narrative">
            {ev.narrative}
          </p>
        )}
      </div>
    </div>
  );
}
